// Canonical color palette for the Atlas UI — the single source of truth for color
// values. The CSS custom properties in styles.ts are generated from these tokens,
// and the globe renderer (three.js) + settings panel read the JS tokens directly.
// Update colors here only; do not hand-mirror values into styles.ts.
export const colors = {
  black: '#000000',
  // UI borders
  borderLight: '#e5e5e5',
  // Chart colors
  chartsPrimary: '#535CFF',
  chartsSequential100: '#E6F9FB',
  chartsSequential200: '#B3EFF5',
  chartsSequential300: '#68F0FD',

  chartsSequential400: '#02B8CA',
  chartsSequential500: '#535CFF',
  // Fog palette
  fog100: '#F5F5F6',
  fog200: '#E2E2E3',
  fog300: '#CCCCCC',
  fog400: '#CCCCCC',

  fog500: '#707070',

  fog700: '#434343',
  // Globe renderer colors — consumed by three.js and the settings panel defaults
  // (rendered to canvas, not via CSS variables).
  globe: {
    dots: '#f0f0f0',
    fillLight: '#e5edff',
    gradientBottom: '#000000',
    gradientMiddle: '#0f172a',
    gradientTop: '#000000',
    rimLight: '#cfff4d',
  },
  stickerBlue: '#8dbafe',
  stickerDarkGrey: '#848484',
  stickerGreen: '#66dcb1',
  stickerGrey: '#cccccc',
  stickerLavender: '#C4B5FD',

  stickerOrange: '#febf5c',
  stickerRed: '#FCA5A5',
  stickerTeal: '#68F0FD',
  // Sticker colors (status filter + table; Figma Background/Sticker)
  stickerWhite: '#FFFFFF',
  stickerYellow: '#FDE047',
  text: '#000000',
  textInverse: '#ffffff',
  textPrimary: '#313131',
  textSecondary: '#707070',

  // Brand
  ube: '#4349e6',

  // Core colors
  white: '#ffffff',
} as const

// Dark-theme overrides for the admin experience only (applied under
// :root[data-theme="dark"]). These remap the semantic surface/text/border
// tokens so admin views and the reused detail cards flip cleanly. Sticker
// background colors and --text-primary are intentionally left at their light
// values: sticker variants pair a bright fill with dark text, which stays
// high-contrast on a dark page. Emitted as CSS variables by styles.ts.
export const darkColors = {
  borderLight: '#2a2f37',
  fog100: '#0e0f12',
  fog200: '#22262d',
  fog300: '#2f343c',
  fog400: '#3a4049',
  fog500: '#8b919b',
  fog700: '#c6cad1',
  text: '#e8eaed',
  textSecondary: '#9aa1ab',
  // Card/surface background (admin uses --white as the elevated surface token).
  white: '#181a20',
} as const
